module.exports = ".modal-backdrop {\n  position: fixed !important; }\n\n.modal {\n  position: none !important; }\n\n.modal .container {\n    min-width: auto !important; }\n\n.modal-body {\n  min-height: 30vh; }\n\n.modal .modal-btn .close-x {\n  position: absolute;\n  color: #fff;\n  right: 4px !important;\n  top: -7px !important;\n  padding: 4px;\n  font-size: 26px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/modal/modal.component.scss
// module id = ./src/app/shared-components/modal/modal.component.scss
// module chunks = main